import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { ResponseMessage, RootState, UtenteLoginModel } from '../types';

Vue.use(Vuex);

const store = new Vuex.Store<RootState>({
    state: {
        working: false,
        applicationMessage: null as ResponseMessage | null,
        loggedUser: null as UtenteLoginModel | null,
        drawer: true,
        drawerMini: true
    },
    mutations: {
        startWorking: (state) => state.working = true,
        stopWorking: (state) => state.working = false,
        setApplicationMessage: (state, applicationMessage: ResponseMessage) => {
            state.applicationMessage = applicationMessage;
            if (state.applicationMessage) {
                state.applicationMessage.isError = !state.applicationMessage.type || state.applicationMessage.type.toLowerCase().endsWith('exception');
            }
        },
        clearApplicationMessage: (state) => state.applicationMessage = null,
        setLoggedUser: async (state, loggedUser) => {
            if (loggedUser) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${loggedUser.token}`;
                if (process.env.NODE_ENV !== 'production') {
                    localStorage.setItem('medicina-legale/loggedUser', JSON.stringify(loggedUser));
                }
            }
            else {
                delete axios.defaults.headers.common['Authorization'];
                if (process.env.NODE_ENV !== 'production') {
                    localStorage.removeItem('medicina-legale/loggedUser');
                }
            }
            state.loggedUser = loggedUser;
        },
        toggleDrawer: (state) => state.drawer = !state.drawer,
        closeDrawer: (state) => state.drawer = false,
        toggleDrawerMini: (state) => state.drawerMini = !state.drawerMini,
    },
    getters: {
        isAuthenticated: (state) => state.loggedUser !== null && state.loggedUser.token !== null,
    },
    actions: {
        setUser({ commit }, user) {
            commit('setLoggedUser', user);
        },
        toggleDrawer({ commit }) {
            commit('toggleDrawer');
        },
        closeDrawer({ commit }) {
            commit('closeDrawer');
        },
        toggleDrawerMini({ commit }) {
            commit('toggleDrawerMini');
        },

    },
    modules: {}
});

if (process.env.NODE_ENV !== 'production') {
    if (localStorage.getItem('medicina-legale/loggedUser') != null && JSON.parse(localStorage.getItem('medicina-legale/loggedUser') ?? '')) {
        store.dispatch('setUser', JSON.parse(localStorage.getItem('medicina-legale/loggedUser') ?? ''));
    }
}

export default store;